import {useEffect} from 'react';

export default function useModalWatcher() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      const modals = document.querySelectorAll('.modal');
      const modalInput = document.querySelectorAll('.modal-input');

      backdrops.forEach((el, i) => {
        const idx = 1240 + (i * 20)
        el.style.zIndex = `${idx}`;
      });

      modals.forEach((el, i) => {
        const idx = 1250 + (i * 20)
        el.style.zIndex = `${idx}`;
      });

      modalInput.forEach((el, i) => {
        const idx = 1250 + (i * 20) + 1
        el.style.zIndex = `${idx}`;
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
}
